export default __webpack_public_path__ + "static/media/EM1080.34I-27372_-23961_0.f5ca3b7d.jpg";